module.exports = __webpack_public_path__ + "static/sprout-off-the-wall_ceramic-mixed-media-3ft-approx-3e723ddd74f2e51e4d96ce8469f7c2a1.jpg";